import { RouterProvider } from 'react-router-dom';
import { router } from './routes/router';
import 'react-photo-view/dist/react-photo-view.css';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import Aos from 'aos';
import { Toaster } from 'react-hot-toast';


import {
  QueryClient,
  QueryClientProvider,
} from 'react-query'
const queryClient = new QueryClient()

function App() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, [])
  return (
    <div className='font-sans'>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router}></RouterProvider>
        <Toaster />
      </QueryClientProvider>
    </div>
  );
}

export default App;
